<!-- FOOTER -->
<footer id="footer-1" class="wide-40 footer division">
    <div class="container">

        <!-- FOOTER CONTENT -->
        <div class="row">

            <!-- FOOTER INFO -->
            <div class="col-md-6 col-lg-3">
                <div class="footer-info mb-40">

                    <!-- Footer Logo -->
                    <!-- For Retina Ready displays take a image with double the amount of pixels that your image will be displayed (e.g 360 x 80  pixels) -->
                    <img src="assets/images/logo (2).png" width="180" height="40" alt="footer-logo">

                    <!-- Text -->
                    <p class="p-sm mt-20">We bring innovation and care together to ensure faster, smarter treatment for every patient
                    </p>

                    <!-- Social Icons -->
                    <div class="footer-socials-links mt-20">
                        <ul class="foo-socials text-center clearfix">

                            <li><a href="https://www.facebook.com/mdclinic4u/" class="ico-facebook"><i class="fab fa-facebook-f"></i></a></li>
                            <li><a href="https://www.instagram.com/miangpollyclinic?utm_source=qr&igsh=dzkxaGo3cnRpNGgw" class="ico-tumblr"><i class="fab fa-instagram"></i></a></li>
                        </ul>
                    </div>

                </div>
            </div>


            <!-- FOOTER CONTACTS -->
            <div class="col-md-6 col-lg-3">
                <div class="footer-box mb-40">

                    <!-- Title -->
                    <h5 class="h5-xs">Our Location</h5>

                    <!-- Address -->
                    <p>Bashir NeuroSpine Institute, next to Services Hospital, Jail Road</p>
                    <p>Lahore , Pakistan</p>

                    <!-- Email -->
                    <p class="foo-email mt-20">Email: <a href="mailto:info@movementcliniclahore.com">infomovementclinic&#64;gmail.com</a></p>

                    <!-- Phone -->
                    <p>Phone# : +92 308 7912740</p>

                </div>
            </div>


            <!-- FOOTER WORKING HOURS -->
            <div class="col-md-6 col-lg-3">
                <div class="footer-box mb-40">

                    <!-- Title -->
                    <h5 class="h5-xs">Working Time</h5>

                    <!-- Working Hours -->
                    <p class="p-sm">Mon - Sun - <span>24 Hours</span></p>
                    

                </div>
            </div>


            <!-- FOOTER PHONE NUMBER -->
            <div class="col-md-6 col-lg-3">
                <div class="footer-box mb-40">

                    <!-- Title -->
                    <h5 class="h5-xs">Emergency Cases</h5>

                    <!-- Footer List -->
                    <strong class="h5-xl blue-color">+92 308 7912740</strong>
                    <p class="h5-xl blue-color">Ptcl: <strong class="h5-xl blue-color">04237268300</strong></p>

                    <!-- Text -->
                    <p class="p-sm mt-15"> Our clinic combines modern technology with expert care to deliver the best healthcare experience
                    </p>

                </div>
            </div>


        </div> <!-- END FOOTER CONTENT -->


        <!-- FOOTER COPYRIGHT -->
       <div class="bottom-footer">
            <div class="row">
                <div class="col-md-6 col-12">
                    <p class="footer-copyright">� 2025 <span>Movement Clinic</span>. All Rights Reserved</p>
                </div>
                <div class="col-md-6 col-12">
                    <p class="footer-copyright" style="float: right;">Powered by <a style="font-weight: bold; text-decoration: dashed;" target="_blank" href="https://squarecod.com/">SquareCod</a></p>
                </div>
            </div>
        </div>


    </div> <!-- End container -->
</footer> <!-- END FOOTER-1 -->